import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { SessionDataService } from "../../../../services/shared/SessionDataService.service";
import { TranslateModule } from "@ngx-translate/core";
import { MatButtonModule } from "@angular/material/button";

/**
 * Dialog listing the latest patch notes and module versions, opened from the footerbar.
 * `data` carries `latestPatchInfo` and `appVersion`.
 */
@Component({
  selector: "app-footerbar-dialog",
  templateUrl: "./footerbar-dialog.component.html",
  styleUrls: ["./footerbar-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, TranslateModule]
})
export class FooterbarDialogComponent {
  /***************************************************************************/
  // ANCHOR Variables
  /***************************************************************************/

  @Input() data: any;

  /***************************************************************************/
  // ANCHOR Constructor
  /***************************************************************************/

  constructor(public SessionDataService: SessionDataService) {}
}
